import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ButtonComponent from "../ButtonComponent/ButtonComponent";
import "./BecomeCareprenur.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";

const BecomeCareprenur = ({ mobileInputRef }) => {
  let mobile = localStorage.getItem("mobileno");
  const [mobileno, setMobileNo] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const { isLoggedIn, user } = useAuth();

  const handleNavigate = () => {
    if (!mobileno || mobileno.length !== 10) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }
    setError("");
    setMobileNo("");
    navigate("/login", { state: { mobileno } });
  };
  let profileCompleted = localStorage.getItem("profile_completed");

  return (
    <>
      <div className="bg-img-1">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h4 className="text-h4">
                Become a CarePreneur with Wihan – Shape the Future of Home
                Healthcare
              </h4>
            </div>
            <div className="col-md-6">
              <img
                src={require("../../Assets/img2.png")}
                alt=""
                className="img-fluid"
              />
            </div>
          </div>
        </div>
        <div
          className={`bg-thick-blue ${
            isLoggedIn ? "logged-in-padding" : "logged-out-padding"
          }`}
        >
          <div>
            <p>
              Join Hyderabad’s fastest-growing network of nurses, caregivers,
              physiotherapists, and doctors delivering compassionate care at
              home. Work flexibly, earn competitively, and make a real impact in
              people’s lives.
            </p>
          </div>
          {!isLoggedIn && (
            <div className="flex-d g_16">
              <div
                className="phone-input"
                style={{ border: error ? "1px solid red" : "" }}
              >
                <span className="prefix">+91</span>
                <input
                  ref={mobileInputRef}
                  name="mobileno"
                  type="text"
                  inputMode="numeric"
                  maxLength={10}
                  className="number-input"
                  value={mobileno}
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/\D/g, "");
                    setMobileNo(onlyNums);
                  }}
                />
              </div>

              <div>
                <ButtonComponent
                  title="Login"
                  onClick={handleNavigate}
                  style={{ width: "100px" }}
                />
              </div>
            </div>
          )}

          <div className="d-flex justify-content-center">
            {error && <span className="mobile-error">{error}</span>}
          </div>
        </div>
      </div>
    </>
  );
};

export default BecomeCareprenur;
